export default __webpack_public_path__ + "static/media/img6.635e46ec.png";